import { createModel } from "@rematch/core";
import { ErrorPayload, ErrorState, } from "src/types";
import { v4 as uuid } from "uuid";

import { RootModel } from ".";

const initialState: ErrorState = {
    errors: []
};
export const errors = createModel<RootModel>()({
    state: initialState as typeof initialState,
    reducers: {
        newError(state, payload: ErrorPayload) {
            return {
                ...state,
                errors: state.errors.concat([{ ...payload, uuid: uuid() }])
            };
        },
        reset() {
            return initialState
        }
    },
});



// WEBPACK FOOTER //
// ./src/models/errors.ts